import { ChangeDetectionStrategy, Component, computed, signal } from "@angular/core";
import { TabConfig } from "src/app/shared/ui/tabs/tabs.component";
import { CONFIGURATIONS_TABS } from "./content.constants";

@Component({
  selector: "configuration-area-content",
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfigurationAreaContentComponent {
  readonly tabs = CONFIGURATIONS_TABS;

  readonly tab = signal("concession");
  readonly childTab = signal("modules");

  readonly childTabs = computed<Array<TabConfig>>(
    () => this.tabs.find(({ name }) => name === this.tab())?.childTabs ?? []
  );

  setTab(tab: string): void {
    this.tab.set(tab);
    this.childTab.set(this.childTabs()[0]?.name);
  }
}
